import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2766252f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar" }
const _hoisted_2 = { class: "category" }
const _hoisted_3 = { class: "btn-link" }

import {ref,Ref,onMounted} from 'vue'
  import ShopService from '@/services/ShopService'
  import Category from '@/interfaces/ShopInterface';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'NavBar',
  setup(__props) {

  const loading= ref(false)
  const category: Ref<Array<Category>> = ref([])
  const service = new ShopService()  
  onMounted(async()=>{
    loading.value = true
    category.value = await service.ListAllCategories()
    loading.value = false
})
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.value, (elm) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "options",
          key: elm.id
        }, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(elm.name), 1)
        ]))
      }), 128))
    ])
  ]))
}
}

})